module.exports = __webpack_public_path__ + "img/Logo_Asset.1be216db.png";